import { graphql } from 'gatsby';
import { VersatileLink } from '../types/types';

export const NavigationMenuFragment = graphql`
  fragment NavigationMenu on SanityMenuSingleEntry {
    __typename
    ... on SanityMenuSingleEntry {
      title {
        ...LocaleStringFragment
      }
      internalLink {
        pageReference {
          ...PageReference
        }
        anchorLink
      }
      externalLink {
        url
      }
    }
  }
`;

export type SingleEntry = {
  title: string;
} & VersatileLink;

export interface NestedEntry {
  title: string;
  entries: Array<SingleEntry>;
}

export type NavigationMenu = Array<SingleEntry>;

export function isNestedEntry(entry: SingleEntry | NestedEntry): entry is NestedEntry {
  return 'entries' in entry;
}
